// extracted by mini-css-extract-plugin
module.exports = {"root":"SideBySide_root__SEgbL","center":"SideBySide_center__UgFXk"};